export const FILE_TYPES = {
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  jpg: 'image/jpg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  video: 'video/mp4',
  mov: 'video/quicktime',
  wmv: 'video/x-ms-wmv',
  flv: 'video/x-flv',
} as const;

export const ONLY_SUPPORTS = {
  image: 'Only supports .jpg, .jpeg and .png',
  pdf: 'Only supports .pdf',
  doc: 'Only supports .doc and .docx',
  pdfAndDoc: 'Only supports .pdf, .doc, .docx, .xls and .ppt',
  video: 'Only supports .mp4, .mov, .wmv and .flv',
} as const;

export const MEDIA_TYPES = {
  image: 'IMAGE',
  pdf: 'PDF',
  document: 'DOCUMENT',
  video: 'VIDEO',
} as const;

export const fileTypeValidationMap = {
  [MEDIA_TYPES.document]: {
    types: [FILE_TYPES.doc, FILE_TYPES.docx],
    msg: ONLY_SUPPORTS.doc,
  },
  [MEDIA_TYPES.image]: {
    types: [FILE_TYPES.jpeg, FILE_TYPES.jpg, FILE_TYPES.png],
    msg: ONLY_SUPPORTS.image,
  },
  [MEDIA_TYPES.pdf]: {
    types: [
      FILE_TYPES.pdf,
      FILE_TYPES.doc,
      FILE_TYPES.docx,
      FILE_TYPES.xls,
      FILE_TYPES.xlsx,
      FILE_TYPES.ppt,
      FILE_TYPES.pptx,
    ],
    msg: ONLY_SUPPORTS.pdfAndDoc,
  },
  [MEDIA_TYPES.video]: {
    types: [FILE_TYPES.video, FILE_TYPES.mov, FILE_TYPES.wmv, FILE_TYPES.flv],
    msg: ONLY_SUPPORTS.video,
  },
};
